import { render, staticRenderFns } from "./EscolhaOpcaoSelect.vue?vue&type=template&id=57481218&"
import script from "./EscolhaOpcaoSelect.vue?vue&type=script&lang=js&"
export * from "./EscolhaOpcaoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VAutocomplete,VChipGroup,VSheet})
